import { WeblabTreatment, Treatment } from '../types/weblab-types'
import { WeblabInitResult, WeblabInitFn } from '../provider/weblabs_provider'
import { getCookie } from '../../cookie_helper'

const NEO_WEBLAB_COOKIE = 'experiment'

const createCookieWeblabsInit = (): WeblabInitFn => {
  return async (principal: string): Promise<WeblabInitResult> => {
    const weblabs = getCookie(NEO_WEBLAB_COOKIE)
    if (weblabs.length === 0) {
      return {
        weblabs: [],
        principal: '',
      }
    }
    const weblabsArray = weblabs.slice(1, -1).split('&')
    const weblabTreatments: WeblabTreatment[] = []

    weblabsArray.forEach(weblab => {
      const weblabTreatment = weblab.split(':')
      weblabTreatments.push({
        weblab: weblabTreatment[0],
        treatment: weblabTreatment[1] as Treatment,
      })
    })

    return {
      weblabs: weblabTreatments,
      principal: principal,
    }
  }
}

export const cookieWeblabsInit: WeblabInitFn = createCookieWeblabsInit()
